const wikilink = /\[\[([^\]\n]+)\]\]/g;
const fencePattern = /^ {0,3}(`{3,}|~{3,})/;

function rewriteProse(text: string): string {
  return text.replace(wikilink, (_match, target: string) => {
    const [slug = "", label = slug] = target
      .split("|", 2)
      .map((part) => part.trim());
    return `[${label}](${slug})`;
  });
}

function inlineCodeEnd({
  line,
  openEnd,
  openLength,
}: Readonly<{
  line: string;
  openEnd: number;
  openLength: number;
}>): number {
  let position = openEnd;

  while (position < line.length) {
    if (line[position] !== "`") {
      position++;
      continue;
    }

    const runStart = position;

    while (line[position] === "`") position++;

    if (position - runStart === openLength) return position;
  }

  return -1;
}

function rewriteLine(line: string): string {
  let result = "";
  let position = 0;

  while (position < line.length) {
    const tickStart = line.indexOf("`", position);

    if (tickStart === -1) {
      result += rewriteProse(line.slice(position));
      break;
    }

    result += rewriteProse(line.slice(position, tickStart));
    let tickEnd = tickStart;

    while (line[tickEnd] === "`") tickEnd++;

    const spanEnd = inlineCodeEnd({
      line,
      openEnd: tickEnd,
      openLength: tickEnd - tickStart,
    });

    if (spanEnd === -1) {
      result += rewriteProse(line.slice(tickStart));
      break;
    }

    result += line.slice(tickStart, spanEnd);
    position = spanEnd;
  }

  return result;
}

export function rewriteWikilinks(body: string): string {
  let fenceCharacter: string | undefined;
  let fenceLength = 0;
  // Run before GFM parses tables so a wikilink label's pipe stays inside its cell.
  return body
    .split("\n")
    .map((line) => {
      const fence = fencePattern.exec(line)?.[1];

      if (fenceCharacter) {
        if (
          fence &&
          fence[0] === fenceCharacter &&
          fence.length >= fenceLength &&
          line.trim() === fence
        ) {
          fenceCharacter = undefined;
        }

        return line;
      }

      if (fence) {
        fenceCharacter = fence[0];
        fenceLength = fence.length;
        return line;
      }

      return rewriteLine(line);
    })
    .join("\n");
}
